import { DataTable, Dialog, Heading, Loader } from "@/components"
import useViewDetails from "./useViewJobDetails";
import { capitalize } from "@/lib/utils";
import { Button } from "@/components/ui";
import { ArrowDownToLine } from "lucide-react";

const ViewJobDetails = () => {
  const {columns, title, breadcrumbData, isLoadingJobDetails, jobDetails, distributionJobDtl,
    isSimulate, openDocDialog, setOpenDocDialog, selectRowDocs, docColumns
  } = useViewDetails();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={title} breadcrumbData={breadcrumbData} />
        </div>
        <div className="flex flex-row gap-3 items-center">
          <span className="text-[20px] font-semibold text-primary">{capitalize(distributionJobDtl?.budgetType)}</span>
          {isSimulate ? <></> : <Button className="bg-green-700 hover:bg-green-700">Export Details <ArrowDownToLine className="stroke-2"/> </Button>}
        </div>
      </div>

      {isLoadingJobDetails ? 
        <Loader /> : 
        <DataTable data={jobDetails} columns={columns} hideFooter />
      }
      <Dialog
        open={openDocDialog}
        setOpen={setOpenDocDialog}
        title={<div className="text-2xl font-bold text-primary">
          {"Doc ID / Line ID"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>}
        hideFooter
      >
        <DataTable
          data={selectRowDocs || []}
          columns={docColumns}
          hideFooter
          className="shadow-none border-0"
          tableWrapperClassName="p-0"
        />
      </Dialog>
    </div>
  )
}

export default ViewJobDetails;